<section class="gradient-section-theme-color1">
  <div class="container">
    <h1>
      BMI Calculator
    </h1>
  </div>
</section>

<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/">Home</a></li>
      <li class="breadcrumb-item"><a href="/tools">Tools</a></li>
      <li class="breadcrumb-item active" aria-current="page">Date and Time Tools</li>
    </ol>
  </nav>

  <div class="mt-5">
    <div class="bmi-calculator">
      <p>Use this tool to calculate your Body Mass Index (BMI). Enter your height in centimeters and weight in
        kilograms,
      then click the "Calculate BMI" button to see your result.</p>

      <form [formGroup]="bmiForm" (ngSubmit)="calculateBMI()" class="bmi-form">
        <div class="form-group">
          <label for="height">Height (cm):</label>
          <input type="number" id="height" formControlName="height" class="form-control" required>
        </div>
        <div class="form-group">
          <label for="weight">Weight (kg):</label>
          <input type="number" id="weight" formControlName="weight" class="form-control" required>
        </div>
        <div class="form-group mt-3">
          <button type="submit" class="btn btn-primary">Calculate BMI</button>
        </div>
      </form>
      <div class="col-xs-12" style="height:50px;"></div>

      @if (bmiResult !== null) {
        <div>
          <div>Your BMI is: {{ bmiResultStr }}</div>
                <div [ngClass]="{
                    'text-success': bmiResult < 18.5,
                    'text-primary': bmiResult >= 18.5 && bmiResult <= 24.9,
                    'text-warning': bmiResult >= 25 && bmiResult <= 29.9,
                    'text-danger': bmiResult >= 30
                }">
            @if (bmiResult < 18.5) {
              Underweight
            }
            @if (bmiResult >= 18.5 && bmiResult <= 24.9) {
              Optimum range
            }
            @if (bmiResult >= 25 && bmiResult <= 29.9) {
              Overweight
            }
            @if (bmiResult >= 30 && bmiResult <= 34.9) {
              Class I obesity
            }
            @if (bmiResult >= 35 && bmiResult <= 39.9) {
              Class II obesity
            }
            @if (bmiResult >= 40) {
              Class III obesity
            }
          </div>
        </div>
      }
    </div>

    <div class="bmi-info mt-4">
      <h3>BMI Categories:</h3>
      <ul>
        <li><strong class="text-success">Underweight:</strong> Less than 18.5.</li>
        <li><strong class="text-primary">Optimum range:</strong> 18.5 to 24.9.</li>
        <li><strong class="text-warning">Overweight:</strong> 25 to 29.9.</li>
        <li><strong class="text-danger">Class I obesity:</strong> 30 to 34.9.</li>
        <li><strong class="text-danger">Class II obesity:</strong> 35 to 39.9.</li>
        <li><strong class="text-danger">Class III obesity:</strong> More than 40.</li>
      </ul>
    </div>
  </div>
</div>

<div class="col-xs-12" style="height:50px;"></div>
